export default __webpack_public_path__ + "static/media/share.8da259be.svg";